

import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import SingleSelectField from '../../commons/fields/SingleSelectField.vue'

@Component({
  components: {
    SingleSelectField
  }
})
export default class SelectFundingScope extends Vue {
  @Prop() fundingScopeSlug!: string
  @Prop() availableFundingScopes!: string[]
  @Prop({ default: '' }) hintHtml!: string
  @Prop({ default: false }) isDisabled!: boolean
  @Prop({ default: false }) readOnly!: boolean
  @Prop() formErrors!: { funding_scope: string }

  selectedFundingScope = ''

  mounted () {
    this.selectedFundingScope = this.fundingScopeSlug
  }

  @Watch('fundingScopeSlug')
  onFundingScopeSlugChanged(newVal: string) {
    this.$emit('update:fundingScopeSlug', newVal)
  }
}
